import { render } from "./ControlePermissoesIndex.vue?vue&type=template&id=e36581bc&scoped=true&ts=true"
import script from "./ControlePermissoesIndex.vue?vue&type=script&lang=ts"
export * from "./ControlePermissoesIndex.vue?vue&type=script&lang=ts"

import "./ControlePermissoesIndex.vue?vue&type=style&index=0&id=e36581bc&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e36581bc"]])

export default __exports__